<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-partners
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-user-tie mr-2'></i> Partners</h4>"
          v-else
        ></table-partners>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TablePartners from "./TablePartners";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import ModalCreatePartner from "../notifications/ModalCreatePartner";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "partners",
  components: {
    TablePartners,
    SemipolarSpinner,
    ModalCreatePartner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "email", label: "Correo", sortable: true },
        { key: "country", label: "País", sortable: true },
        { key: "phone", label: "Télefono", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getPartners();
  },
  methods: {
    getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          shuffleArray([partners]);
          this.isLoading = false;
          this.items = partners;
          this.itemsArray = partners;
        });
      } else {
        shuffleArray([partners]);
        this.items = partners;
        this.itemsArray = partners;
      }
    }
  }
};
</script>
